import React, { useEffect } from 'react';

import {
  selectQualificationLevelPrerequisites,
  selectSelectedQualificationLevel,
  setQualificationLevel,
} from 'store/exams-search/examsSearchSlice';
import { useAppDispatch, useAppSelector } from 'store';
import { useLazyGetQualificationLevelsQuery } from 'store/exams-search/examsSearchAPI';

import { ApiErrorPage, BcSelect } from '@britishcouncil/react-solas-ors3';
import { Alert, LoadingContainer } from '@britishcouncil/react-solas';

export const QualificationLevelSelect = () => {
  const dispatch = useAppDispatch();
  const qualificationLevelPrerequisites = useAppSelector(selectQualificationLevelPrerequisites);
  const qualificationLevel = useAppSelector(selectSelectedQualificationLevel);

  const [triggerQualificationLevelQuery, { data, error, isFetching }] = useLazyGetQualificationLevelsQuery();

  useEffect(() => {
    const { complete, ...params } = qualificationLevelPrerequisites;
    if (qualificationLevelPrerequisites.complete) {
      triggerQualificationLevelQuery({
        ...params,
        sessionId: params.session!.sessionId
      });
    }
  }, [triggerQualificationLevelQuery, qualificationLevelPrerequisites]);

  if (!qualificationLevelPrerequisites.complete) return null;

  if (error) return <ApiErrorPage />;

  return (
    <LoadingContainer loading={isFetching}>
      {data && data.length === 0 && <Alert type="warning">There are currently no qualification levels</Alert>}
      {data && data.length > 0 && (
        <>
          <label htmlFor="qualification-select">Qualification level</label>
          <BcSelect
            id="qualification-select"
            isLoading={isFetching}
            options={data}
            value={qualificationLevel}
            onChange={(selected: unknown) => dispatch(setQualificationLevel(selected as string))}
            placeholder="Select qualification level"
          />
        </>
      )}
    </LoadingContainer>
  );
};
